export default async ({ store }) => {
  store.dispatch('settings/loadConfigurations', true, { root: true })
}
